import api from '../../../App/socket';

export const changePriceOMConfig = (_id, config) => api.send({
    api: 'db',
    model: 'Priceomatic_configuration',
    action: 'Update',
    options: {
        update: config,
        where: { _id },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/requests/change_priceom_config_request.js